import React, { useState } from 'react';
import {
  Card,
  Row,
  Col,
  Button,
  Form,
  Alert,
  Toast,
  ToastContainer,
  Accordion,
  Spinner,
} from 'react-bootstrap';
import {
  QuestionCircle,
  Envelope,
  Telephone,
  InfoCircle,
  Send,
} from 'react-bootstrap-icons';

const HelpPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [sent, setSent] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', variant: 'success' });

  const showToast = (message, variant = 'success') => {
    setToast({ show: true, message, variant });
    setTimeout(() => setToast((prev) => ({ ...prev, show: false })), 4000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => {
      showToast('Message envoyé. Notre équipe vous répondra rapidement.', 'success');
      setFormData({ name: '', email: '', subject: '', message: '' });
      setSent(false);
    }, 800);
  };

  const faqs = [
    {
      question: "Comment puis-je consulter mon dossier médical ?",
      answer: "Connectez-vous à votre espace patient, puis cliquez sur 'Mon dossier médical' dans le menu de gauche. Vous y trouverez l'historique de vos consultations, prescriptions et analyses."
    },
    {
      question: "Comment obtenir ma carte électronique ?",
      answer: "Votre carte électronique est automatiquement générée lors de votre inscription. Vous pouvez la télécharger depuis votre espace patient, rubrique 'Ma carte'."
    },
    {
      question: "Que faire en cas de perte de mon code d'accès ?",
      answer: "Utilisez la fonction 'Mot de passe oublié' sur la page de connexion. Un lien de réinitialisation vous sera envoyé par email."
    },
    {
      question: "Comment signaler un problème technique ?",
      answer: "Utilisez le formulaire de contact ci-dessous. Précisez le plus de détails possible (type d'erreur, captures d'écran, etc.) pour faciliter le traitement."
    }
  ];

  return (
    <div className="" style={{ fontFamily: "'Inter', sans-serif" }}>
      <ToastContainer className="p-3" style={{ zIndex: 9999, position: 'fixed', top: '20px', right: '20px' }}>
        <Toast show={toast.show} onClose={() => setToast((prev) => ({ ...prev, show: false }))} bg={toast.variant} delay={4000} autohide>
          <Toast.Header closeButton={false}>
            <strong className="me-auto">
              {toast.variant === 'success' ? 'Succès' : toast.variant === 'danger' ? 'Erreur' : 'Information'}
            </strong>
          </Toast.Header>
          <Toast.Body className="text-white">{toast.message}</Toast.Body>
        </Toast>
      </ToastContainer>

      <div className="container-fluid">
        {/* En-tête */}
        <div className="mb-4">
          <h4 className="main-title mb-0 d-flex align-items-center gap-2">
            <div className="bg-primary bg-opacity-10 rounded-circle p-2">
              <QuestionCircle size={24} className="text-primary" />
            </div>
            Centre d'aide
          </h4>
          <p className="text-muted mb-0 mt-1">
            Trouvez des réponses à vos questions ou contactez notre support
          </p>
        </div>

        <Row className="g-4">
          {/* FAQ */}
          <Col lg={7}>
            <Card className="border-0 shadow-sm" style={{ borderRadius: '16px' }}>
              <Card.Header className="bg-white border-0 pt-4 pb-4 px-4">
                <h5 className="fw-semibold mb-0">Foire aux questions</h5>
              </Card.Header>
              <Card.Body className="p-4">
                <Accordion defaultActiveKey="0">
                  {faqs.map((faq, idx) => (
                    <Accordion.Item eventKey={idx.toString()} key={idx}>
                      <Accordion.Header>{faq.question}</Accordion.Header>
                      <Accordion.Body>{faq.answer}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </Card.Body>
            </Card>
          </Col>

          {/* Contact */}
          <Col lg={5}>
            <Card className="border-0 shadow-sm" style={{ borderRadius: '16px' }}>
              <Card.Header className="bg-white border-0 pt-4 pb-4 px-4">
                <h5 className="fw-semibold mb-0">Contactez-nous</h5>
              </Card.Header>
              <Card.Body className="p-4">
                <div className="d-flex flex-column gap-3 mb-4">
                  <div className="d-flex align-items-center gap-3">
                    <Envelope size={20} className="text-primary" />
                    <div>
                      <div className="small text-muted">Email</div>
                      <strong>support@cnamgs.ga</strong>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3">
                    <Telephone size={20} className="text-primary" />
                    <div>
                      <div className="small text-muted">Téléphone</div>
                      <strong>+241 01 23 45 67</strong>
                    </div>
                  </div>
                </div>
                <hr />
                <h6 className="fw-semibold mb-3">Envoyer un message</h6>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nom</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Sujet</Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <Button
                    type="submit"
                    variant="primary"
                    className="rounded-pill w-100"
                    disabled={sent}
                  >
                    {sent ? <Spinner size="sm" className="me-1" /> : <Send size={16} className="me-1" />}
                    {sent ? 'Envoi...' : 'Envoyer'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <style>{`
          .card {
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .card:hover {
            transform: translateY(-4px);
            box-shadow: 0 12px 20px -8px rgba(0, 0, 0, 0.15) !important;
          }
          .accordion-button:not(.collapsed) {
            background-color: #eef2ff;
            color: #4361ee;
          }
        `}</style>
      </div>
    </div>
  );
};

export default HelpPage;